var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-tabs',{attrs:{"tabs":_vm.tabs,"activeTab":_vm.activeTab,"breadcrumbMode":false,"clickable":true},on:{"click":_vm.tabClicked},scopedSlots:_vm._u([{key:"tab",fn:function(ref){
var tabTitle = ref.tabTitle;
var tabDescription = ref.tabDescription;
return [_c('div',{staticClass:"text-sm font-bold tracking-wide uppercase"},[_vm._v(_vm._s(tabTitle))]),_c('div',{staticClass:"text-sm text-neutral-600"},[_vm._v(_vm._s(tabDescription))])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }